import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PrimeiroAcessoReducedForm from './PrimeiroAcessoReducedForm';
import PrimeiroAcessoFullForm from './PrimeiroAcessoFullForm';

export default function PrimeiroAcesso({ isOpen, onlyAno = false, onSuccess }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50 p-4" aria-modal="true" role="dialog">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-sm">
        <h2 className="text-2xl font-bold text-center mb-2 text-gray-800">Complete seu Perfil</h2>
        <p className="text-center text-gray-600 mb-6">Este é seu primeiro acesso, preencha os dados para continuar.</p>
        {onlyAno ? (
          <PrimeiroAcessoReducedForm onSuccess={onSuccess} />
        ) : (
          <PrimeiroAcessoFullForm onSuccess={onSuccess} />
        )}
      </div>
    </div>
  );
}